import { Field, Form, Formik } from 'formik';
import { Visibility } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { Box, LinearProgress, CardContent, CircularProgress, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import EyeClose from '../../assets/fonts/eye-close.svg';
import ButtonMain from '../Shared/ButtonMain';
import TextFieldMain from '../Shared/TextFieldMain';
import { AlertErroMain } from './AlertErroMain';
import useResetPasswordHook from './useResetPasswordHook';
import LoaderMain from '../Shared/LoaderMain';
import './styles.scss';
import FundoPadrao from '../Login/FundoPadrao';

const ResetPassword = () => {
  const {
    isPending,
    message,
    mostrarErro,
    textoForcaSenha,
    setValueCPF,
    progress,
    valuesPassword,
    valuesRepeatPassword,
    messageLocal,
    resetPasswordHandler,
    handleChangePassword,
    handleClickShowPassword,
    handleMouseDownPassword,
    validateInputs
  } = useResetPasswordHook();

  return (
    <FundoPadrao>
      <CardContent className="reset-password">
        {isPending && <LoaderMain />}
        <Grid container className={`${isPending ? 'display-none' : ''}`}>
          <Grid item xl={1} lg={1} md={1} sm={1} xs={1} />
          <Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
            {message === 'Senha atualizada' ? (
              <Box>
                <Typography variant="h5" className="texto-negrito texto-centro label-acessar-conta">
                  Senha alterada
                </Typography>

                <Typography
                  variant="subtitle1"
                  className="texto-descricao texto-cor-cinza-escuro texto-centro"
                >
                  Utilize o e-mail e a nova senha cadastrada para acessar sua conta.
                </Typography>

                <Box className="text-center mt-5 mb-5">
                  <Typography variant="subtitle1" className="texto-link-redefinir">
                    <Link className="link-criar-conta" to="/login">
                      <Typography>Voltar para início</Typography>
                    </Link>
                  </Typography>
                </Box>
              </Box>
            ) : (
              <Box>
                <Typography
                  variant="h5"
                  className="texto-negrito texto-centro label-acessar-conta ajuste-titulo"
                >
                  Nova senha
                </Typography>
                <Formik
                  initialValues={{ cpf: '', password: '', repeatPassword: '' }}
                  validateOnChange={false}
                  validateOnBlur={false}
                  validate={validateInputs}
                  onSubmit={resetPasswordHandler}
                >
                  {({ values, isSubmitting }) => {
                    const passwordIsFilled = !!values.password?.trim();
                    const documentoIsFilled = !!values.cpf?.trim();
                    const repeatPasswordIsFilled = !!values.repeatPassword?.trim();

                    return (
                      <Form>
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography className="texto-cor-principal">CPF</Typography>
                            <Field
                              type="text"
                              name="cpf"
                              titulo="cpf"
                              placeholder="000.000.000-00"
                              component={TextFieldMain}
                              inputClassName={`w-100 ${documentoIsFilled ? 'is-filled' : ''}`}
                              size="small"
                              onChangeInput={e => setValueCPF(e.target.value)}
                              uppercase={false}
                              autoComplete="off"
                              tipoMascara="CPFMask"
                              disabled={isPending || isSubmitting}
                            />

                            <Typography className="texto-cor-principal mt-3">Senha</Typography>
                            <Field
                              name="password"
                              component={TextFieldMain}
                              tipoComponente="outlineInput"
                              type={valuesPassword.showPassword ? 'text' : 'password'}
                              value={valuesPassword.password}
                              onChangeInput={e => handleChangePassword(e, 'password')}
                              inputClassName={`w-100 ${passwordIsFilled ? 'is-filled' : ''}`}
                              size="small"
                              autoComplete="new-password"
                              disabled={isPending || isSubmitting}
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={() => handleClickShowPassword('password')}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                  >
                                    {valuesPassword.showPassword ? (
                                      <Visibility />
                                    ) : (
                                      <img src={EyeClose} alt="icone olho fechado" />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              }
                            />

                            <Typography variant="subtitle1" className={textoForcaSenha.corForcaSenha}>
                              {textoForcaSenha.msgForcaSenha}
                            </Typography>
                            {textoForcaSenha.msgForcaSenha && (
                              <Box>
                                <LinearProgress
                                  variant="determinate"
                                  value={progress}
                                  color={textoForcaSenha.corProgress}
                                />
                              </Box>
                            )}

                            <Typography className="texto-cor-principal mt-3">Confirmar Senha</Typography>
                            <Field
                              name="repeatPassword"
                              component={TextFieldMain}
                              tipoComponente="outlineInput"
                              type={valuesRepeatPassword.showRepeatPassword ? 'text' : 'password'}
                              value={valuesRepeatPassword.repeatPassword}
                              onChangeInput={e => handleChangePassword(e, 'repeatPassword')}
                              inputClassName={`w-100 ${repeatPasswordIsFilled ? 'is-filled' : ''}`}
                              size="small"
                              disabled={isPending || isSubmitting}
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={() => handleClickShowPassword('repeatPassword')}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                  >
                                    {valuesRepeatPassword.showRepeatPassword ? (
                                      <Visibility />
                                    ) : (
                                      <img src={EyeClose} alt="icone olho fechado" />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              }
                            />

                            {messageLocal && (
                              <Typography
                                variant="subtitle1"
                                className="texto-danger pad-10 texto-centro"
                              >
                                {messageLocal}
                              </Typography>
                            )}
                            {mostrarErro && (
                              <AlertErroMain
                                exibeErro={mostrarErro}
                                escondeErro={setMostraErro}
                                msgErro={typeof mostrarErro === 'string' ? mostrarErro : ''}
                              />
                            )}
                          </Grid>
                        </Grid>

                        <Grid container spacing={2} className="mt-3 mb-4">
                          <Grid item xs={12}>
                            <ButtonMain
                              type="submit"
                              disabled={
                                isPending ||
                                isSubmitting ||
                                !passwordIsFilled ||
                                !documentoIsFilled ||
                                !repeatPasswordIsFilled
                              }
                              className="button-cor-cliente min-heith-42"
                            >
                              {!isPending && <>Cadastrar nova senha</>}
                              {isPending && <CircularProgress size={24} color="inherit" />}
                            </ButtonMain>
                          </Grid>
                        </Grid>
                      </Form>
                    );
                  }}
                </Formik>
              </Box>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </FundoPadrao>
  );
};

export default ResetPassword;
